import React, { useState, useEffect } from "react";

//components
import CustomBreadcrumbs from "../../Components/CustomBreadcrumbs";
import DashboardHeader from "../../ClientEngagement/DashboardHeader";
import CustomFileDropper from "../../Components/CustomFileDropper";
import CustomColorPicker from "../../Components/CustomColorPicker";

//utils
import { axiosInstance } from "../../utils/axiosInterceptor";
import {
  Box,
  createTheme,
  ThemeProvider,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import { MenuItem } from "@material-ui/core";
import { printingData } from "./createProject.data";
// import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";

//styles
import {
  PageContainer,
  CreateProjectContainer,
  CreateProjectFormContainer,
  CusotmGridItem,
  CustomInput,
  CustomSelect,
  LightTooltip,
  CustomSlider,
  CustomButton,
} from "./CreateNewProject.styles";

//assets
import { ReactComponent as InfoLogo } from "../../assests/InfoLogo.svg";

// const dropzoneTheme = createTheme({
//   overrides: {
//     root: {
//       backgroundColor: "transparent",
//     },
//   },
// });

const Create3dPrintingProject = ({ isAdmin }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [createLoading, setCreateLoading] = useState(false);
  const [cadFile, setCadFile] = useState(null);
  const [errors, setErrors] = useState({
    quantityError: false,
  });
  const [userEmail, setUserEmail] = useState("");

  const [projectData, setProjectData] = useState({
    printingService: null,
    quantity: 0,
    projectName: "",
    material: "",
    colour: "",
    printQuality: "",
    surfaceFinish: "",
    otherSpecification: "",
  });

  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const fetchProfile = () => {
    setLoading(true);
    axiosInstance
      .get("/users/getProfile")
      .then((resp) => {
        setProfile(resp.data);
        console.log(resp);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    setProjectData({
      ...projectData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    console.log(projectData);
    console.log(cadFile);

    //quantity check
    if (isNaN(Number(projectData.quantity)) || Number(projectData.quantity)==0) {
      setErrors({
        ...errors,
        quantityError: true,
      });
      enqueueSnackbar("Quantity should be a valid number and greater than 0", {
        variant: "error",
      });
      return;
    }

    if (cadFile === null || projectData.colour == "") {
      if (cadFile === null) {
        enqueueSnackbar("Please upload a cad file.", { variant: "info" });
        return;
      }
      if (projectData.colour == "") {
        enqueueSnackbar("Please select a colour", { variant: "info" });
        return;
      }
    }
    let formData = new FormData();
    formData.append("cad", cadFile);
    // formData.append("printingService", projectData.printingService);
    for (let i in projectData) {
      formData.append(i, projectData[i]);
    }

    for (let pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }
    setCreateLoading(true);

    const token = localStorage.getItem("token");
    try {
      let url;
      if (isAdmin) {
        url = "/3d/admin/createProject/threeDPrinting";
        formData.append("userEmail", userEmail);
      } else {
        url = "/3d/client/createProject/threeDPrinting";
      }
      const res = await axiosInstance.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-type": "multipart/form-data",
        },
      });
      console.log(res);
      enqueueSnackbar("Project Created Successfully!", {
        variant: "success",
      });
      setCreateLoading(false);
      if (isAdmin) {
        history.push(`/admin/3d/timeline/3dprinting/${res.data.project._id}`);
      } else {
        history.push(`/3dcolosseum/3dprinting/${res.data.project._id}`);
      }
    } catch (err) {
      console.log(e);
      enqueueSnackbar("some error occurred", { variant: "error" });
    }
  };

    useEffect(() => {
        if(localStorage.PM && history.location.pathname.includes("/admin")) history.push("/pm/3d/newProject/3dPrinting");    
    }, []);
  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <Box>
      {!loading ? (
        <PageContainer>
          <DashboardHeader profile_data={profile.data} isBlack={true} />
          <CreateProjectContainer>
            <CustomBreadcrumbs
              data={[
                {
                  name: "Home",
                  link: "/",
                },
                {
                  name: "EB 3D Colosseum",
                  link: "/admin/3d",
                },
                {
                  name: "Create new project",
                  link: "/admin/3d/services",
                },
                {
                  name: "3D Printing",
                  link: history.location.pathname,
                },
              ]}
            />
            <div className="title">3D Printing - Create a new Project</div>
            <CreateProjectFormContainer>
              <div className="dropzone-container">
                <CustomFileDropper setFile={setCadFile} single />
              </div>
            
              <form onSubmit={handleFormSubmit}>
                <Grid container spacing={5}>
                  <CusotmGridItem item md={6}>
                    <div className="grid-item-inner">
                      <label htmlFor="project-name">Project Name*</label>
                      <CustomInput
                        type="text"
                        id="project-name"
                        name="projectName"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </CusotmGridItem>
                  {/* <CusotmGridItem item md={6} shift>
                    <div className="grid-item-inner">
                      <label htmlFor="quantity">Quantity*</label>
                      <CustomInput
                        type="text"
                        id="quantity"
                        name="quantity"
                        onChange={handleChange}
                        required
                        error={errors.quantityError}
                      />
                    </div>
                  </CusotmGridItem> */}
                  <CusotmGridItem item md={6} shift></CusotmGridItem>
                  <CusotmGridItem item md={6}>
                    <div className="grid-item-inner">
                      <label htmlFor="printingService">Printing Service*</label>
                      <LightTooltip
                        title={
                          <React.Fragment>
                            <Typography
                              sx={{ fontSize: "1.3em", marginBottom: "10px" }}
                            >
                              <b>FDM</b> - Fused Deposition Modeling (FDM)
                              Technology works with specialized 3D printers and
                              production - grade thermoplastics to build strong,
                              durable and dimensionally stable parts with the
                              best accuracy and repeatability
                            </Typography>
                            <Typography
                              sx={{ fontSize: "1.3em", marginBottom: "10px" }}
                            >
                              <b>SLA</b> – Stereolithography (SLA) 3D printing,
                              or resin 3D printing, has ability to produce high
                              - accuracy, isotropic, and watertight prototypes
                              and parts in a range of advanced materials with
                              fine features and smooth surface finish.
                            </Typography>{" "}
                            <Typography
                              sx={{ fontSize: "1.3em", marginBottom: "10px" }}
                            >
                              <b>MJF</b>- Multi Jet Fusion is an industrial 3D
                              printing process that produces functional nylon
                              prototypes and end - use production parts in as
                              fast as 1 day. Final parts exhibit quality surface
                              finishes, fine feature resolution, and more
                              consistent mechanical properties.
                            </Typography>
                          </React.Fragment>
                        }
                        placement="right"
                      >
                        <InfoLogo
                          height="15px"
                          width="15px"
                          style={{ marginLeft: "10px" }}
                        />
                      </LightTooltip>
                      <CustomSelect
                        variant="outlined"
                        value={projectData.printingService}
                        onChange={handleChange}
                        name="printingService"
                        id="printingService"
                        required
                      >
                        <MenuItem value="FDM">FDM</MenuItem>
                        <MenuItem value="SLA">SLA</MenuItem>
                        <MenuItem value="MJF">MJF</MenuItem>
                      </CustomSelect>
                    </div>
                  </CusotmGridItem>{" "}
                  <CusotmGridItem item md={6} shift></CusotmGridItem>
                  <CusotmGridItem item md={6}>
                    <div className="grid-item-inner">
                      <label htmlFor="quantity">Quantity*</label>
                      <CustomInput
                        type="text"
                        id="quantity"
                        name="quantity"
                        onChange={handleChange}
                        required
                        error={errors.quantityError}
                      />
                    </div>
                  </CusotmGridItem>
                  <CusotmGridItem item md={6} shift>
                    <div className="grid-item-inner">
                      <label htmlFor="material">Material*</label>
                      <CustomSelect
                        variant="outlined"
                        id="material"
                        onChange={handleChange}
                        disabled={projectData.printingService === null}
                        name="material"
                        required
                      >
                        {projectData.printingService === null
                          ? null
                          : printingData[
                              projectData.printingService
                            ].material.map((material) => (
                              <MenuItem value={material}>{material}</MenuItem>
                            ))}
                      </CustomSelect>
                    </div>
                  </CusotmGridItem>
                  <CusotmGridItem item md={6}>
                    <div className="grid-item-inner">
                      <label htmlFor="project-name">Colour*</label>
                      <CustomColorPicker
                        colors={
                          projectData.printingService === null
                            ? printingData.FDM.colors
                            : printingData[projectData.printingService].colors
                        }
                        disabled={projectData.printingService === null}
                        onChange={(c) => {
                          setProjectData({ ...projectData, colour: c });
                        }}
                      />
                    </div>
                  </CusotmGridItem>
                  {projectData.printingService === "FDM" ||
                  projectData.printingService === null ? (
                    <CusotmGridItem item md={6} shift>
                      <div className="grid-item-inner">
                        <label htmlFor="printQuality">Print Quality*</label>
                        <CustomSelect
                          variant="outlined"
                          id="printQuality"
                          onChange={handleChange}
                          name="printQuality"
                          disabled={
                            projectData.printingService === "SLA" ||
                            projectData.printingService === "MJF" ||
                            projectData.printingService === null
                          }
                          required
                        >
                          {projectData.printingService === null
                            ? null
                            : printingData[
                                projectData.printingService
                              ].printQuality.map((p) => (
                                <MenuItem value={p.val}>{p.label}</MenuItem>
                              ))}
                        </CustomSelect>
                      </div>
                    </CusotmGridItem>
                  ) : (
                    <CusotmGridItem item md={6} shift>
                      <div className="grid-item-inner">
                        <label htmlFor="surfaceFinish">Surface Finish*</label>
                        <CustomSelect
                          variant="outlined"
                          id="surfaceFinish"
                          onChange={handleChange}
                          name="surfaceFinish"
                          disabled={projectData.printingService === null}
                          required
                        >
                          <MenuItem value="standard">Standard</MenuItem>
                          <MenuItem value="custom">Custom</MenuItem>
                        </CustomSelect>
                      </div>
                    </CusotmGridItem>
                  )}
                  {isAdmin ? (
                    <CusotmGridItem item md={6}>
                      <div className="grid-item-inner">
                        <label htmlFor="user-email">User Email*</label>
                        <CustomInput
                          type="text"
                          id="user-email"
                          name="userEmail"
                          onChange={(e) => {
                            setUserEmail(e.target.value);
                          }}
                          required
                          value={userEmail}
                        />
                      </div>
                    </CusotmGridItem>
                  ) : null}
                  {/* <CusotmGridItem item md={6}>
                    <div className="grid-item-inner">
                      <label htmlFor="project-name">In-fill*</label>
                      <Box>
                        <CustomSlider
                          size="small"
                          defaultValue={20}
                          aria-label="Small"
                          valueLabelDisplay="auto"
                          disabled={
                            projectData.printingService === "SLA" ||
                            projectData.printingService === "MJF" ||
                            projectData.printingService === null
                          }
                          required
                          min={20}
                          onChange={(e, nv) => {
                            setProjectData({
                              ...projectData,
                              infill: nv,
                            });
                          }}
                        />
                      </Box>
                    </div>
                  </CusotmGridItem> */}
                  <CusotmGridItem item md={12} isLast>
                    <div className="grid-item-inner">
                      <label htmlFor="otherSpecification">
                        Anyother Specification
                      </label>
                      <CustomInput
                        type="text"
                        id="otherSpecification"
                        multiline
                        rows={4}
                        name="otherSpecification"
                        onChange={handleChange}
                        placeholder="Additional Service may include rotation in X & Y axis, polishing, drilling and treading, tapping, beading, etc."
                      />
                    </div>
                  </CusotmGridItem>
                </Grid>
                <CustomButton
                  variant="contained"
                  type="submit"
                  loading={createLoading}
                  loadingPosition="end"
                >
                  Submit
                </CustomButton>
              </form>
            </CreateProjectFormContainer>
          </CreateProjectContainer>
        </PageContainer>
      ) : null}
    </Box>
  );
};

export default Create3dPrintingProject;
